import { ITag } from "../interfaces/Tag";
import { stringTagList } from "./defaultValues";

export const getDefaultTextValue = (stringTagList: ITag[], id: any) => {
  const tag = stringTagList.find((tag) => tag.id === id);
  if(tag) return tag.defaulttext;
  return "";
};

export const stringTagListDD = stringTagList.map((tag) => {
  return {
    key: tag.id,
    text: tag.name,
    value: tag.id,
  };
});